import React, { Component } from "react";
import { connect } from "react-redux";

//common components
import NavBar from "../../../../../_components/common/Navbar";
import Footer from "../../../../../_components/common/Footer";
import SettingsHead from "../../../../../_components/common/SettingsHead";
import ModalNew2 from "../../../../../_components/common/ModalNew2";
import CustomTableNew from "../../../../../_components/common/CustomTableNew";
import { CommonBreadCrumb } from "../../../../../_components/common/CommonBreadCrumb";
import { LoaderComp } from "../../../../../_components/common/LoaderComp/Loadercomp";
import Page404 from "../../../../404page";

//private components
import Modal from "./Modal";

//formData
import formData from "./formData";

//actions
import { addManageMetricAction } from "../../../../../_actions/organisations/ManageMetric/addManageMetric.action";

import { updateManageMetricAction } from "../../../../../_actions/organisations/ManageMetric/updateManageMetric.action";
import { organisationAction } from "../../../../../_actions/organisation.action";
import { RoleFitmentReportAction } from "../../../../../_actions/organisations/roleFitmentReport/roleFitmentReport.action";

class RoleFitmentReport extends Component {
  state = {
    addModal: false,

    tableDetails: false,

    tableEdit: false,

    tableDelete: false,

    tableAttrData: [],

    editDataState: {},

    editColumnData: [
      {
        key: "competency_pre_fill",
        type: "select",
        value: "",
        selected: false,
        valid: true,
        regex: "^\\d+$",
        elementConfig: {
          name: "competency_name",
          label: "Prefill Attributes",
          options: [],
          storeKey: [
            "CompetencyMetricPrefill",
            "data",
            "data",
            "competency_metrics"
          ]
        },
        validation: {
          required: false,
          message: ""
        }
      },
      {
        key: "competency_type",
        type: "select",
        value: "",
        selected: true,
        valid: true,
        regex: "^\\d+$",
        elementConfig: {
          name: "competency_name",
          label: "Type",
          options: [],
          storeKey: [
            "ManageCompetencyList",
            "data",
            "data",
            "compitency_type_list"
          ]
        },
        validation: {
          required: true,
          message: ""
        }
      },
      {
        key: "competency_name",
        type: "text",
        value: "",
        valid: true,
        regex: "",
        elementConfig: {
          name: "competency_name_name",
          label: "Name",
          placeholder: ""
        },
        validation: {
          required: true,
          message: "is required"
        }
      },
      {
        key: "description",
        type: "text",
        value: "",
        valid: true,
        regex: "",
        elementConfig: {
          name: "description",
          label: "Description",
          placeholder: ""
        },
        validation: {
          required: true,
          message: "is required"
        }
      }
    ],

    orgId: 0,

    hasProperOrgId: true,
    idLoader: true,

    formDataState: formData,
    fitment_competencies: [],
    filtered_fitment_competencies: [],
    currentSelectedOption: 0
  };

  componentDidMount() {
    const { dispatch } = this.props;

    let orgIdFromPath = this.props.location.pathname.match(/\d/g);
    orgIdFromPath = orgIdFromPath.join("");

    this.setState(
      {
        orgId: orgIdFromPath
      },
      () => {
        const { orgId } = this.state;
        this.getRoleFitmentList({ orgId });
        dispatch(
          RoleFitmentReportAction.getOrganisationFitmentsListAction({ orgId })
        );

        let hasId = false;

        dispatch(
          organisationAction.getOrganisation(callback_Data => {
            for (
              let i = 0;
              i < callback_Data.data.organisation_list.length;
              i++
            ) {
              const element = callback_Data.data.organisation_list[i];
              if (element.id == orgId) {
                hasId = true;
              }
            }
            this.setState({
              hasProperOrgId: hasId,
              idLoader: false
            });
          })
        );
      }
    );
  }

  componentDidUpdate(prevProps, prevStates) {
    if (
      prevProps.holder_list_and_organisation_competency !==
      this.props.holder_list_and_organisation_competency
    ) {
      this.setState({
        filtered_fitment_competencies: this.props
          .holder_list_and_organisation_competency
          .organisation_compitency_metric_list
      });
    }

    if (
      prevStates.tableEdit !== this.state.tableEdit
    ) {
      if (!this.state.tableEdit) {
        this.setState({
          fitment_competencies: []
        })
      }
    }
  }

  getRoleFitmentList = ({ orgId }) => {
    const { dispatch } = this.props;

    dispatch(
      RoleFitmentReportAction.getHolderAndOrganisationCompetencyAction(
        { orgId },
        {
          successCallback: response => {
            this.setState({
              formDataState: {
                ...this.state.formDataState,
                add: this.addOptionsToSelect(this.state.formDataState.add)
              }
            });
          }
        }
      )
    );
  };

  addModalToggler(showModal, type) {
    this.setState({
      addModal: showModal
    });
  }

  addMatrixAction(data) {
    const { dispatch } = this.props;

    let attrData = [];
    data.data.map(val => {
      attrData.push({
        attribute: val.id !== undefined ? val.id : val.attribute_id,
        competency_weight: val.competency_weight
      });
    });

    let addMatrixData = {
      competency_type: parseInt(data.sellerData.competency_type, 10),
      top_five_name: "",
      competency_name: data.sellerData.competency_name,
      description: data.sellerData.description,
      organisation: parseInt(this.state.orgId, 10),
      compentency_values: attrData
    };

    dispatch(
      addManageMetricAction.addManageMetricHandler(
        this.state.orgId,
        0,
        addMatrixData
      )
    );
  }

  modalOpener(data) {

  }

  tableDetailsToggler(bool) {
    this.setState({
      tableDetails: bool
    });
  }

  tableEditToggler(data) {
    this.setState({
      tableEdit: data
    });
  }

  tableDeleteToggler(data) {
    this.setState({
      tableDelete: data
    });
  }

  tableButton(data, rowData) {
    if (data.content === "DETAILS") {
      this.setState(
        {
          tableAttrData: rowData
        },
        () => {
          this.tableDetailsToggler(true);
        }
      );
    } else if (data.content === "EDIT") {
      const currentRow = this.props.organisation_fitments_list.find(value => {
        return value == rowData;
      });

      if (currentRow) {
        const {
          formDataState: { edit: formData }
        } = this.state;

        const {
          holder_list_and_organisation_competency: { holder_list }
        } = this.props;
        const {
          holder_list_and_organisation_competency: { band_list }
        } = this.props;
        const updatedFormData = formData.map(item => {
          if (item.refer_key === "name") {
            return {
              ...item,
              input_value: currentRow.holder_id,
              input_valid: true,
              elementConfig: {
                ...item.elementConfig,
                options: holder_list
              }
            };
          } else if (item.refer_key === "band_name") {
            return {
              ...item,
              input_value: currentRow.band_id,
              input_valid: true,
              elementConfig: {
                ...item.elementConfig,
                options: band_list
              }
            };
          } else if (item.refer_key === "fitment_name") {
            return {
              ...item,
              input_value: currentRow.fitment_name,
              input_valid: true,
              input_hidden: false
            };
          } else if (item.refer_key === "competency_name") {
            const isPrefilled = !!currentRow.master_fitment_id; // Check if the fitment is prefilled
            const prefillAttributeOption = item.elementConfig.options.find(
              (option) => option.id === currentRow.master_fitment_id
            ); // Find the corresponding option based on the master_fitment_id
            return {
              ...item,
              input_value: isPrefilled ? currentRow.master_fitment_id : "",
              input_valid: isPrefilled,
              input_hidden: false,
              elementConfig: {
                ...item.elementConfig,
                options: this.getFitmentsFromHolder({
                  value: currentRow.holder_id,
                  holder_list
                })
              }
            };
          }
          return { ...item, input_hidden: false };
        });

        const {
          holder_list_and_organisation_competency: {
            organisation_compitency_metric_list
          }
        } = this.props;
        this.setState(
          {
            formDataState: {
              ...this.state.formDataState,
              edit: updatedFormData
            },
            fitment_competencies: currentRow.organisation_fitment_competency.map(
              item => ({
                ...item,
                competency_name: item.competency__competency_name
              })
            ),
            filtered_fitment_competencies: organisation_compitency_metric_list,
            tableAttrData: rowData
          },
          () => {
            this.tableEditToggler(true);
          }
        );

      }
    } else if (data.content === "DELETE") {
      this.setState(
        {
          tableAttrData: rowData
        },
        () => {
          this.tableDeleteToggler(true);
        }
      );
    }
  }

  editMetricAction(data) {
    const { dispatch } = this.props;

    let attrData = [];
    data.data.map(val => {
      this.props.attributeData.map(value => {
        if (val.attribute__attribute_name === value.attribute_name) {
          attrData.push({
            attribute: value.id,
            competency_weight: val.competency_weight
          });
        }
      });
    });

    let editMetricData = {
      competency_type: parseInt(data.sellerData.competency_type, 10),
      top_five_name: "",
      competency_name: data.sellerData.competency_name,
      description: data.sellerData.description,
      organisation: parseInt(this.state.orgId, 10),
      compentency_values: attrData
    };

    dispatch(
      updateManageMetricAction.updateManageMetricHandler(
        this.state.orgId,
        this.state.tableAttrData.id,
        editMetricData
      )
    );
  }

  deleteMetricData(data) {
    const { dispatch } = this.props;
    const { orgId } = this.state;

    dispatch(
      RoleFitmentReportAction.deleteOrganisationFitmentsAction({
        orgId,
        fitment_id: this.state.tableAttrData.id,
        requestObject: {
          org_fitment_id: this.state.tableAttrData.id
        },
        callback: () =>
          dispatch(
            RoleFitmentReportAction.getOrganisationFitmentsListAction({ orgId })
          )
      })
    );
    this.tableDeleteToggler(false);
  }

  changeFormData = (form_update_key, { value, refer_key, data }) => {
    const updatedFormData = data.map(item => {
      if (refer_key === item.refer_key) {
        return value;
      }
      return item;
    });
    if (refer_key === "name") {
      const {
        holder_list_and_organisation_competency: { holder_list }
      } = this.props;
      const updatedFormDataWithFitments = updatedFormData.map(item => {
        if (value.input_valid) {
          if (item.refer_key === "competency_name") {
            return {
              ...this.addFitmentOptionsToSelect({
                _item: item,
                holder_list,
                holderValue: value.input_value
              }),
              input_hidden: false
            };
          } else if (item.refer_key === "fitment_name") {
            return {
              ...item,
              input_hidden: false
            };
          }
          return {
            ...item,
            input_hidden: !value.input_valid
          };
        }
        if (item.refer_key === refer_key) {
          return item;
        }
        if (item.refer_key === "competency_name") {
          return {
            ...item,
            input_value: "",
            elementConfig: {
              ...item.elementConfig,
              options: []
            },
            input_hidden: true
          };
        } else if (item.refer_key === "is_prefilled_fitment") {
          return {
            ...item,
            input_hidden: true
          };
        }
        return { ...item, input_value: "", input_hidden: true };
      });
      if (value.input_valid) {
        this.setState({
          fitment_competencies: []
        });
      }
      this.setState({
        formDataState: {
          ...this.state.formDataState,
          [form_update_key]: updatedFormDataWithFitments
        }
      });
    } else if (refer_key === "is_prefilled_fitment") {
      const hideOtherInputs = updatedFormData.map(item => {
        if (item.refer_key === "competency_name") {
          return {
            ...item,
            input_hidden: !value.input_value,
            input_value: ""
          };
        } else if (item.refer_key === "fitment_name") {
          return {
            ...item,
            input_hidden: value.input_value,
            input_value: "",
            input_valid: false
          };
        }
        return item;
      });
      const {
        holder_list_and_organisation_competency: {
          organisation_compitency_metric_list
        }
      } = this.props;
      this.setState({
        formDataState: {
          ...this.state.formDataState,
          [form_update_key]: hideOtherInputs
        },
        fitment_competencies: [],
        filtered_fitment_competencies: value.input_value
          ? this.state.filtered_fitment_competencies
          : organisation_compitency_metric_list
      });
    } else if (refer_key === "competency_name") {
      const getFitmentName = ({ fitment_id, elementConfig }) => {
        const currentFitment = elementConfig.options.find(
          item => item.id == fitment_id
        );
        if (currentFitment) {
          const {
            holder_list_and_organisation_competency: {
              organisation_compitency_metric_list
            }
          } = this.props;
          this.setState({
            fitment_competencies: currentFitment.fitment_competencies,
            filtered_fitment_competencies: this.filterSelectOptions({
              selectOptions: organisation_compitency_metric_list,
              selectedOptions: currentFitment.fitment_competencies
            })
          });
          return currentFitment[elementConfig.option_label_key];
        }
        return "";
      };
      const updatedFormWithFitments = updatedFormData.map(item => {
        if (item.refer_key === "fitment_name") {
          const input_value = getFitmentName({
            fitment_id: value.input_value,
            elementConfig: value.elementConfig
          });
          return {
            ...item,
            input_value,
            input_valid: value.input_valid
          };
        }
        return item;
      });
      this.setState(
        {
          formDataState: {
            ...this.state.formDataState,
            [form_update_key]: updatedFormWithFitments
          }
        },
        () => {
          if (!value.input_valid) {
            this.setState({
              fitment_competencies: []
            });
          }
        }
      );
    } else if (refer_key === "band_name") {
      this.setState({
        formDataState: {
          ...this.state.formDataState,
          [form_update_key]: updatedFormData
        }
      });
    } else {
      const removePreFill = updatedFormData.map(item => {
        if (item.refer_key === "competency_name") {
          return {
            ...item,
            input_value: ""
          };
        }
        return item;
      });
      this.setState({
        formDataState: {
          ...this.state.formDataState,
          [form_update_key]: removePreFill
        }
      });
    }

    if (refer_key === "fitment_name") {
      const prefilledData = updatedFormData.find(item => item.refer_key === "competency_name");
      const fitmentIds = prefilledData.elementConfig.options.map(item => `${item.id}`);
      if ((this.state.tableEdit && this.state.tableAttrData.master_fitment_id) || fitmentIds.includes(prefilledData.input_value)) {
        this.setState({
          fitment_competencies: []
        });
      }
    }
  };

  addOptionsToSelect = _formData => {
    const {
      holder_list_and_organisation_competency: { holder_list }
    } = this.props;

    const {
      holder_list_and_organisation_competency: { band_list }
    } = this.props;
    const updatedFormData = _formData.map(item => {
      if (item.input_type === "select") {
        if (item.refer_key === "name") {
          return this.addHolderOptionsToSelect({ _item: item, holder_list });
        }
        if (item.refer_key === "band_name") {
          return this.addBandOptionsToSelect({ _item: item, band_list });
        }
      }
      return item;
    });
    return updatedFormData;
  };

  addHolderOptionsToSelect = ({ _item, holder_list }) => {
    return {
      ..._item,
      elementConfig: {
        ..._item.elementConfig,
        options: holder_list
      }
    };
  };
  addBandOptionsToSelect = ({ _item, band_list }) => {
    return {
      ..._item,
      elementConfig: {
        ..._item.elementConfig,
        options: band_list
      }
    };
  };

  addFitmentOptionsToSelect = ({ _item, holder_list, holderValue }) => {
    return {
      ..._item,
      elementConfig: {
        ..._item.elementConfig,
        options: this.getFitmentsFromHolder({
          value: holderValue,
          holder_list
        })
      }
    };
  };

  getFitmentsFromHolder = ({ value, holder_list }) => {
    const fitmentsHolder = holder_list.find(item => {
      return value == item.id;
    });
    if (fitmentsHolder) {
      return fitmentsHolder.fitments;
    }
    return [];
  };

  changeFitmentCompetencies = fitment_competencies => {
    this.setState(
      {
        fitment_competencies,
        currentSelectedOption: 0
      },
      () => {
        const { fitment_competencies: selectedOptions } = this.state;
        const {
          holder_list_and_organisation_competency: {
            organisation_compitency_metric_list: selectOptions
          }
        } = this.props;
        this.setState({
          filtered_fitment_competencies: this.filterSelectOptions({
            selectOptions,
            selectedOptions
          })
        });
      }
    );
  };

  changeSelectedOption = currentSelectedOption => {
    this.setState({
      currentSelectedOption
    });
  };

  filterSelectOptions = ({ selectOptions, selectedOptions }) => {
    const selectedOptionsStrings = selectedOptions.map(
      item => item.competency_name
    );
    return selectOptions.filter(item => {
      return !selectedOptionsStrings.includes(item.competency_name);
    });
  };

  checkAddModalDisabled = () => {
    const {
      formDataState: { add: formDataState },
      fitment_competencies
    } = this.state;
    const isFormValid = this.checkFormValid(formDataState);

    let isInvalid = false;
    if (!isFormValid) {
      isInvalid = true;
    }

    if (fitment_competencies.length === 0) {
      isInvalid = true;
    }
    return isInvalid;
  };

  checkEditModalDisabled = () => {
    this.state;
    const {
      formDataState: { edit: formDataState },
      fitment_competencies
    } = this.state;

    const isFormValid = this.checkFormValid(formDataState);
    let isInvalid = false;
    if (!isFormValid) {
      isInvalid = true;
    }

    if (fitment_competencies.length === 0) {
      isInvalid = true;
    }
    return isInvalid;
  };

  checkFormValid = formDataState => {
    const checkList = formDataState.filter(item => item.input_check_valid);
    const validList = checkList.filter(item => item.input_valid);
    return validList.length === checkList.length;
  };

  checkIfDefaultFitment = formDataState => {
    const checkboxInput = formDataState.find(
      item => item.refer_key === "competency_name"
    );
    return checkboxInput.input_valid;
  };

  checkIfPrefillValid = formDataState => {
    const checkboxInput = formDataState.find(
      item => item.refer_key === "competency_name"
    );
    const fitmentInput = formDataState.find(
      item => item.refer_key === "fitment_name"
    );
    const isPreffiled = checkboxInput.elementConfig.options.some(
      item => item.fitment_name === fitmentInput.input_value
    );

    return isPreffiled;
  };

  checkIfHolderSelected = formDataState => {
    const holderInput = formDataState.find(item => item.refer_key === "name");
    return !holderInput.input_valid;
  };

  createRoleFitment = () => {

    const formDataState = this.state.formDataState.add;
    const is_prefilled_fitment = this.checkIfPrefillValid(formDataState);
    const fitment_id = formDataState.find(
      item => item.return_key === "fitment_id"
    ).input_value;
    const band = formDataState.find(item => item.return_key === "band_id")
      .input_value;

    const holder = formDataState.find(item => item.return_key === "holder")
      .input_value;
    const fitment_name = formDataState.find(
      item => item.return_key === "fitment_name"
    ).input_value;
    const competencies = this.state.fitment_competencies.map(item => item.id);
    const requestObject = {
      fitment_id: fitment_id,
      band: band,
      holder: +holder,
      fitment_name: fitment_name,
      is_prefilled_fitment,
      competencies
    };

    const { dispatch } = this.props;
    const { orgId } = this.state;
    dispatch(
      RoleFitmentReportAction.createOrganisationFitmentsAction({
        orgId,
        requestObject,
        callback: () =>
          dispatch(
            RoleFitmentReportAction.getOrganisationFitmentsListAction({ orgId })
          )
      })
    );

    this.resetForm("add", [{
      refer_key: "name",
      return_key: "holder",
      input_type: "select",
      input_value: "",
      input_label: "Holder",
      input_valid: false,
      input_check_valid: true,
      input_regex: "^\\d+$",
      input_placeholder: "",
      input_hidden: false,
      elementConfig: {
        options: this.state.formDataState.add[0].elementConfig.options,
        option_value_key: "id",
        option_label_key: "name"
      }
    },
    {
      refer_key: "band_name",
      return_key: "band_id",
      input_type: "select",
      input_value: "",
      input_label: "Band",
      input_valid: false,
      input_check_valid: true,
      input_regex: "^\\d+$",
      input_placeholder: "",
      input_hidden: true,
      elementConfig: {
        options: this.state.formDataState.add[1].elementConfig.options,
        option_value_key: "id",
        option_label_key: "band_name"
      }
    },
    {
      refer_key: "competency_name",
      return_key: "fitment_id",
      input_type: "select",
      input_value: "",
      input_label: "Prefill Attributes",
      input_valid: false,
      input_check_valid: false,
      input_regex: "^\\d+$",
      input_placeholder: "",
      input_hidden: true,
      elementConfig: {
        options: this.state.formDataState.add[2].elementConfig.options,
        option_value_key: "id",
        option_label_key: "fitment_name"
      }
    },
    {
      refer_key: "fitment_name",
      return_key: "fitment_name",
      input_type: "text",
      input_value: "",
      input_label: "Fitment Name",
      input_valid: false,
      input_check_valid: true,
      input_regex: "^[ A-z0-9]*((- |s)*[ A-z0-9])$",
      input_placeholder: "enter role fitment name ...",
      input_hidden: true,
      elementConfig: {
        options: [],
        option_value_key: "",
        option_label_key: ""
      }
    }])
    this.addModalToggler(false);
  };

  resetForm = (formTypeKey, data) => {
    const {
      formDataState
    } = this.state;
    this.setState({
      formDataState: {
        ...formDataState,
        [formTypeKey]: data
      }
    })
  }

  editRoleFitment = () => {

    const formDataState = this.state.formDataState.edit;
    const is_prefilled_fitment = this.checkIfPrefillValid(formDataState);
    const fitment_id = this.state.tableAttrData.id;
    const holder = formDataState.find(item => item.return_key === "holder")
      .input_value;
    const fitment_name = formDataState.find(
      item => item.return_key === "fitment_name"
    ).input_value;
    const band = formDataState.find(item => item.return_key === "band_id")
      .input_value;
    const competencies = this.state.fitment_competencies.map(item =>
      item.competency_id !== undefined ? item.competency_id : item.id
    );

    const {
      tableAttrData: {
        master_fitment_id = false
      }
    } = this.state;

    const requestObject = {
      fitment_id: master_fitment_id || fitment_id,
      holder: +holder,
      fitment_name: fitment_name,
      is_prefilled_fitment,
      competencies,
      band: band
    };

    const { dispatch } = this.props;
    const { orgId } = this.state;

    dispatch(
      RoleFitmentReportAction.updateOrganisationFitmentsAction({
        orgId,
        fitment_id,
        requestObject,
        callback: () =>
          dispatch(
            RoleFitmentReportAction.getOrganisationFitmentsListAction({ orgId })
          )
      })
    );

    this.tableEditToggler(false);
  };

  render() {
    const {

      organisation_fitments_list,
      organisation_fitments_list_error,
      organisation_fitments_list_loading
    } = this.props;
    const {
      filtered_fitment_competencies,
      fitment_competencies,
      currentSelectedOption
    } = this.state;
    return (
      <div>
        <NavBar />
        {this.state.idLoader ? (
          <div
            style={{ height: "calc(100vh - 150px)" }}
            className="container d-flex justify-content-center"
          >
            <LoaderComp color={"black"} />
          </div>
        ) : this.state.hasProperOrgId ? (
          <div className="container custom-container my-5">
            <div style={{ marginBottom: 30 }}>
              <CommonBreadCrumb
                data={[
                  {
                    link: "/admin/app/dashboard",
                    name: "ADMIN"
                  },
                  {
                    link: "/admin/app/organisation",
                    name: "ORGANISATION"
                  },
                  {
                    link: `/admin/app/organisation/${this.state.orgId}`,
                    name: "ORGANISATION DETAILS"
                  },
                  {
                    link: "",
                    name: "MANAGE ROLES"
                  }
                ]}
              />
              <div className="bg-green rounded-top animation-fade-in">
                {!organisation_fitments_list_error &&
                  !organisation_fitments_list_loading ? (
                  <p className="h6 text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular">
                    MANAGE ROLES{" "}
                  </p>
                ) : (
                  <div className="d-flex justify-content-between">
                    <p></p>
                    <p className="h6 text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular">
                      MANAGE ROLES{" "}
                    </p>
                    <LoaderComp color={"white"} />
                  </div>
                )}
                <SettingsHead
                  buttonData={[
                    {
                      id: 1,
                      heading: "ADD +",
                      state: this.state.addModal,
                      toggler: this.addModalToggler.bind(this)
                    }
                  ]}
                  secondColumn={false}
                  deleteAction={""}
                  widthClass="col-md-12"
                />
                <CustomTableNew
                  data={organisation_fitments_list}
                  columns={[
                    {
                      name: "Name",
                      key: "fitment_name",
                      linkActive: false,
                      link: ""
                    },
                    {
                      name: "Holder",
                      key: "holder__name",
                      linkActive: false,
                      link: ""
                    },
                    {
                      name: "Band",
                      key: "band__band_name",
                      linkActive: false,
                      link: ""
                    },
                    {
                      name: "Details",
                      key: "details",
                      linkActive: false,
                      link: "",
                      type: "button",
                      content: "DETAILS"
                    },
                    {
                      name: "Edit",
                      key: "edit",
                      linkActive: false,
                      link: "",
                      type: "button",
                      content: "EDIT"
                    },
                    {
                      name: "Delete",
                      key: "delete",
                      linkActive: false,
                      link: "",
                      type: "button",
                      content: "DELETE"
                    }
                  ]}
                  showSlNo="false"
                  modalOpener={this.modalOpener.bind(this)}
                  buttonFunc={this.tableButton.bind(this)}
                />
              </div>
              <Modal
                states={{
                  isOpen: {
                    open: this.state.addModal,
                    setOpen: this.addModalToggler.bind(this)
                  },
                  formData: {
                    data: [...this.state.formDataState.add],
                    changeData: data => this.changeFormData("add", data)
                  },
                  competencyData: {
                    selectOptions: filtered_fitment_competencies,
                    selectedOptions: fitment_competencies,
                    updateList: this.changeFitmentCompetencies,
                    currentSelectedOption,
                    changeSelectedOption: this.changeSelectedOption,
                    label_key: "competency_name",
                    hide: this.checkIfHolderSelected(
                      this.state.formDataState.add
                    ),
                    noDelete: this.checkIfPrefillValid(
                      this.state.formDataState.add
                    ),
                    hideDropdown:
                      filtered_fitment_competencies.length <= 0 ||
                      this.checkIfPrefillValid(this.state.formDataState.add)
                  },
                  disabled: this.checkAddModalDisabled()
                }}
                meta={{
                  heading: "Create Role",
                  footer: {
                    save: "Add",
                    cancel: "Cancel"
                  }
                }}
                trigger={this.createRoleFitment}
              />
              <Modal
                states={{
                  isOpen: {
                    open: this.state.tableDetails,
                    setOpen: this.tableDetailsToggler.bind(this)
                  },
                  formData: {
                    data: [],
                    changeData: () => { }
                  },
                  competencyData: {
                    selectedOptions: this.state.tableAttrData
                      .organisation_fitment_competency,
                    noDelete: true,
                    hideDropdown: true,
                    label_key: "competency__competency_name"
                  },
                  disabled: this.checkAddModalDisabled()
                }}
                meta={{
                  heading: "Fitment - DETAILS",
                  footer: {
                    save: null,
                    cancel: "OK"
                  }
                }}
                trigger={() => { }}
              />
              <Modal
                states={{
                  isOpen: {
                    open: this.state.tableEdit,
                    setOpen: this.tableEditToggler.bind(this)
                  },
                  formData: {
                    data: [...this.state.formDataState.edit],
                    changeData: data => this.changeFormData("edit", data)
                  },
                  competencyData: {
                    selectOptions: filtered_fitment_competencies,
                    selectedOptions: fitment_competencies,
                    updateList: this.changeFitmentCompetencies,
                    currentSelectedOption,
                    changeSelectedOption: this.changeSelectedOption,
                    label_key: "competency_name",
                    hide: this.checkIfHolderSelected(
                      this.state.formDataState.edit
                    ),
                    noDelete: this.checkIfPrefillValid(
                      this.state.formDataState.edit
                    ),
                    hideDropdown:
                      filtered_fitment_competencies.length <= 0 ||
                      this.checkIfPrefillValid(this.state.formDataState.edit)
                  },
                  disabled: this.checkEditModalDisabled()
                }}
                meta={{
                  heading: "Edit Role",
                  footer: {
                    save: "Edit",
                    cancel: "Cancel"
                  }
                }}
                trigger={this.editRoleFitment}
              />
              {this.state.tableDelete && (
                <ModalNew2
                  heading="Delete Role"
                  showModal={this.state.tableDelete}
                  formData={[]}
                  action={data => this.deleteMetricData(data)}
                  toggleModal={this.tableDeleteToggler.bind(this)}
                  viewMessage={[{ text: "" }, { text: "Are you Sure?" }]}
                  triggerType={"DELETE"}
                />
              )}
            </div>
          </div>
        ) : (
          <Page404 />
        )}

        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    holder_list_and_organisation_competency_loading,
    holder_list_and_organisation_competency,
    holder_list_and_organisation_competency_error,
    holder_list_and_organisation_competency_error_data
  } = state.getHolderAndOrganisationCompetency;

  const {
    organisation_fitments_list_loading,
    organisation_fitments_list,
    organisation_fitments_list_error,
    organisation_fitments_list_error_data
  } = state.getOrganistionFitmentsList;

  const attributeError = state.ManageAttributeList.error;
  const attributeLoading = state.ManageAttributeList.getAttributeLoading;
  const attributeData =
    !attributeError && !attributeLoading
      ? state.ManageAttributeList.data.data.attributes_list
      : [];

  return {
    holder_list_and_organisation_competency_loading,
    holder_list_and_organisation_competency,
    holder_list_and_organisation_competency_error,
    holder_list_and_organisation_competency_error_data,

    organisation_fitments_list,
    organisation_fitments_list_error,
    organisation_fitments_list_loading,

    attributeData,
    attributeError,
    attributeLoading
  };
};

export default connect(mapStateToProps)(RoleFitmentReport);



// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/DetailLinks/RoleFitmentReport/RoleFitmentReport.jsx